
import { Component, OnInit, inject, viewChild, signal } from "@angular/core";
import { Title } from '@angular/platform-browser';
import { MenuItem } from 'primeng/api';
import { AuthService } from '../auth/auth.service';

@Component({
    standalone: true,
    selector: 'app-topnav',
    templateUrl: './top-nav.component.html',
    styleUrls: ['./top-nav.component.css']
})
export class TopNavComponent implements OnInit {
  private titleService = inject(Title);
  private authService = inject(AuthService);

  readonly items = signal<MenuItem[]>(undefined);
  readonly activeItem = signal<MenuItem>(undefined);

  readonly menu = viewChild<MenuItem[]>('menuItems');

  ngOnInit() {

    this.items.set([
      {label: 'Clienti', icon: 'pi pi-fw pi pi-users', routerLink: '/admin/clients/'},
      {label: 'Appuntamenti', icon: 'pi pi-fw pi pi-calendar-plus', routerLink: '/admin/bookings/'},
      {label: 'Calendario', icon: 'pi pi-fw pi-calendar', routerLink: '/admin/bookings/calendar'},
      {label: 'Fatturazione', icon: 'pi pi-fw ppi pi-credit-card', routerLink: '/admin/billings'},
      {label: 'Timesheet', icon: 'pi pi-fw ppi pi-clock', routerLink: '/admin/timesheets'},

  ]);

  this.activeItem.set(this.items()[0]);

  }

  get isLoggedIn() { return this.authService.isLoggedIn(); }

  setPageTitle(title: string) {
    this.titleService.setTitle(title);
  }

  activateMenu() {
    this.activeItem.set(this.menu()['activeItem']);
 }

}
